import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginWithDiscord, logout } from "../lib/authApi";
import { useAuth } from "../auth/AuthProvider";

export default function AccountMenu() {
    const { user, refresh } = useAuth();
    const nav = useNavigate();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        function onClickOutside(e) {
            if (!ref.current) return;
            if (!ref.current.contains(e.target)) setOpen(false);
        }

        document.addEventListener("mousedown", onClickOutside);
        return () => document.removeEventListener("mousedown", onClickOutside);
    }, []);

    async function onLogout() {
        logout();
        await refresh();
        setOpen(false);
        nav("/manager");
    }

    const displayName =
        user?.display_name ||
        user?.discord_username ||
        user?.email ||
        "Account";

    const avatarUrl = user?.avatar_url;

    if (!user) {
        return (
            <div className="account" ref={ref}>
                <button
                    className="account-login-btn"
                    type="button"
                    onClick={loginWithDiscord}
                >
                    Mit Discord anmelden
                </button>
            </div>
        );
    }

    return (
        <div className="account" ref={ref}>
            <button
                className="account-btn account-btn--profile"
                onClick={() => setOpen((v) => !v)}
                type="button"
                aria-label="Account"
            >
                {avatarUrl ? (
                    <img
                        className="account-avatar"
                        src={avatarUrl}
                        alt=""
                        referrerPolicy="no-referrer"
                    />
                ) : (
                    <span className="account-avatar account-avatar--fallback">
                        {displayName.slice(0, 1).toUpperCase()}
                    </span>
                )}

                <span className="account-name">
                    {displayName}
                </span>
            </button>

            {open && (
                <div className="account-dd">
                    <div className="account-meta">
                        <div className="account-email">{displayName}</div>
                        {user.email && (
                            <div className="account-sub">{user.email}</div>
                        )}
                        <div className="account-role">{user.role}</div>
                    </div>

                    {user.role === "admin" && (
                        <Link
                            className="account-a"
                            to="/manager"
                            onClick={() => setOpen(false)}
                        >
                            Adminbereich
                        </Link>
                    )}

                    <button
                        className="account-a account-a--btn"
                        onClick={onLogout}
                        type="button"
                    >
                        Logout
                    </button>
                </div>
            )}
        </div>
    );
}